/** A complete set of color values for a theme */
export interface ThemeConfiguration {
  primary: string;
  secondary: string;
  accent: string;
  background: string;
  surface: string;
  text: string;
  border: string;
}

/** A named theme with both light and dark color sets */
export interface ThemeDefinition {
  id: string;
  name: string;
  light: ThemeConfiguration;
  dark: ThemeConfiguration;
}

/** Valid values for dark mode localStorage persistence */
export type DarkModePreference = 'dark' | 'light';

/** The required color categories that every ThemeConfiguration must define */
export const REQUIRED_COLOR_CATEGORIES: readonly (keyof ThemeConfiguration)[] = [
  'primary', 'secondary', 'accent', 'background', 'surface', 'text', 'border'
];

/** Storage keys used by theme and dark mode services */
export const STORAGE_KEYS = {
  THEME: 'tenant-portal-theme',
  DARK_MODE: 'tenant-portal-dark-mode',
} as const;
